<template>
  <div class="overlay-block"
       :class="{ 'is-active': isActive, 'is-created': isCreated }"
       @click.self="closeAllOverlayProcesses"
  ></div>
</template>

<script>
export default {
  data () {
    return {
      isActive: false,
      isCreated: false
    }
  },
  created () {
    this.$bus.$on('show-overlay-in-shop', () => this.showOverlay())
    this.$bus.$on('hide-overlay-in-shop', () => this.hideOverlay())
  },
  methods: {
    showOverlay () {
      this.isCreated = true
      setTimeout(() => { this.isActive = true }, 100)
    },
    hideOverlay () {
      this.isActive = false
      setTimeout(() => { this.isCreated = false }, 100)
    },
    closeAllOverlayProcesses () {
      this.hideOverlay()
      this.$bus.$emit('hide-search-panel')
      this.$bus.$emit('hide-burger-menu')
      this.$bus.$emit('clear-search-value')

      if (window.innerWidth < 991) {
        this.$bus.$emit('close-burger')
        this.$bus.$emit('change-close-btn')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay-block {
  width: 100%;
  height: 100%;
  margin: 105px auto auto;

  position: fixed;
  display: none;

  background-color: transparent;
  z-index: 3;
  transition: .2s;

  &.is-created {
    display: flex;
  }

  &.is-active {
    background-color: rgba(#000, .4);
  }
}
</style>
